/**
=========================================================
* Iris Design Limited  Fulfilment POD - v2.2.0
=========================================================

* Product Page: https://www.irisdesignlimited.com/product/material-dashboard-react
* Copyright 2023 Dev Iris Design Limited Company (https://www.irisdesignlimited.com)

Coded by www.irisdesignlimited.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, MenuItem, Select, TextField, Checkbox, FormControlLabel } from '@mui/material';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import HTMLDataTable from "examples/Tables/HTMLDataTable";
import NoteCell from 'examples/NoteCell';
import SizeHtml, { sizeHasHtml } from 'components/SizeHtml';
import TrackingCell from 'examples/TrackingCell';
import "react-datepicker/dist/react-datepicker.css";
import MDPageBar from 'components/MDPagination/MDPageBar';
import { editOrder, getOrders } from "features/slices";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckIcon from '@mui/icons-material/Check';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PhoneInTalkOutlined from '@mui/icons-material/PhoneInTalkOutlined';
import bcrypt from 'bcryptjs';
import { styled } from '@mui/system';
import NoteDialog from 'examples/NoteDialog';
import { updateCurrentPage } from 'features/slices';
import deliStatus from 'layouts/services/contants';
import { NotificationManager } from 'react-notifications';
const Section = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(1),
}));

const GreenSection = styled(Section)({
});

const BlueSection = styled(Section)({
  background: 'linear-gradient(195deg, #9dbdba, #9dbdba)',
  width: "100%",
  display: "flex",
  flexDirection: "row"
});


const DarkSection = styled(Section)({
  background: 'linear-gradient(195deg, #42424a, #191919)',
});

const CaptionText = styled('p')({
  display: "flex",
  flexDirection: "row",
  fontWeight: 'bold',
  marginTop: 4,
  fontSize: "14px",
  color: "#1E293B",
});

const CaptionText2 = styled('p')({
  fontWeight: 'bold',
  marginTop: 4,
  color: "white",
  fontSize: "14px",
});

const InfoText = styled('span')({
  marginLeft: 5,
  color: "#1E293B"
});

const NormalText = styled('span')({
  fontWeight: '400',
  marginLeft: 5,
  color: 'inherit',
});

const HighlightedText = styled('span')({
  fontWeight: '500',
  color: 'orange',
  marginLeft: 5,
  fontSize: "14px"

});

const RedText = styled('span')({
  color: 'red',
  fontWeight: 'bold',
});


function ErrorOrder() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.user.data || []);
  const permission = useSelector((state) => state.user.permission || []);
  const type = useSelector((state) => state.user.type);
  const user = useSelector((state) => state.user.user);
  const filterStore = useSelector((state) => state.user.filterStore);
  const order_status = useSelector((state) => state.user.order_status);
  const startDate = useSelector((state) => state.user.startDate);
  const search = useSelector((state) => state.user.search);
  const currentPage = useSelector((state) => state.user.currentPage) || 1;
  const endDate = useSelector((state) => state.user.endDate);
  const [open2, setOpen2] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [itemEditor, setItemEditor] = useState({})
  const [note, setNote] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const canEditCustomerEmail = permission.includes("is_message_customer");

  console.log(data)

  const handleOpenEmailEditor = (item) => {
    if (!canEditCustomerEmail) return;
    setItemEditor(item);
    setCustomerEmail(item.email || "");
    setOpenEmail(true);
  };

  const handleSaveCustomerEmail = async () => {
    const email = customerEmail.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      NotificationManager.error("Email khách hàng không hợp lệ.", "Error", 2000);
      return;
    }

    const res = await dispatch(editOrder({
      user,
      field: "email",
      string: email,
      id: itemEditor.id,
    }));
    if (res.payload?.status == 0) {
      setOpenEmail(false);
    }
  };

  const handleChangeDeli = async (event, items) => {
    const res = await dispatch(editOrder({ field: "error_order", string: event.target.value, id: items.order_id, store_name: items.store_name, user }))
    if (res.payload.status == 0) {
      // await dispatch(
      //   getOrders({
      //     store: filterStore, order_status,
      //     startDate: moment(startDate).startOf("day").format("x"),
      //     endDate: moment(endDate).endOf("day").format("x"), currentPage, search, type, error_order: true
      //   })
      // );
      bcrypt.genSalt(10, (err, salt) => {
        bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
          const time = moment().unix()
          const res = await dispatch(getOrders({
            store: filterStore, order_status,
            startDate: moment(startDate).startOf("day").format("x"),
            endDate: moment(endDate).endOf("day").format("x"),
            currentPage,
            search,
            version: hash,
            type, error_order: true
          }))

        });
      })
    }
  };
  const handleCopyClick = (text) => {
    NotificationManager.success(`Copied tracking.`, "Error", 700);
    navigator.clipboard.writeText(text)
      .catch(err => console.error('Failed to copy text: ', err));
  };

  const handleCopyEmail = (email) => {
    const value = String(email || "").trim();
    if (!value) return;
    NotificationManager.success("Copied email.", "Success", 700);
    navigator.clipboard.writeText(value)
      .catch((err) => console.error("Failed to copy email: ", err));
  };

  const handleChangePage = async (newPage) => {
    await dispatch(updateCurrentPage(newPage))
  };

  const handleChangeNote = async (e) => {
    const res = await dispatch(editOrder({ user, field: "note", string: !itemEditor.note ? `${user.replace("@gmail.com", "")}: ${note}` : `${itemEditor.note}\n${user.replace("@gmail.com", "")}:${note}`, id: itemEditor.id }))
    if (res.payload.status == 0) {
      
      // bcrypt.genSalt(10, (err, salt) => {
      //   bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
      //     const time = moment().unix()
      //     const res = await dispatch(getOrders({
      //       store: filterStore, order_status,
      //       startDate: moment(startDate).startOf("day").format("x"),
      //       endDate: moment(endDate).endOf("day").format("x"),
      //       currentPage,
      //       search,
      //       version: hash,
      //       type, error_order: true
      //     }))

      //   });
      // })
    }
    setOpen2(false)
  }

  const handleShowInformation = (item) => {
    setItemEditor(item)
    setOpen4(true)
  }

  const handleAddNote = (item) => {
    setNote("")
    setItemEditor(item)
    setOpen2(true)
  };

  const handleClose2 = () => {
    setOpen2(false);
  };
  const handleClose4 = () => {
    setOpen4(false);
  };


  const changeCheckBox = async (items, checked, field, id) => {
    setItemEditor(items)
    const res = await dispatch(editOrder({ user, field, boolean: checked, id }))
    if (res.payload.status == 0) {
      // await dispatch(
      //   getOrders({
      //     store: filterStore, order_status,
      //     startDate: moment(startDate).startOf("day").format("x"),
      //     endDate: moment(endDate).endOf("day").format("x"),
      //     currentPage, search, type, error_order: true
      //   })
      // );
      bcrypt.genSalt(10, (err, salt) => {
        bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
          const time = moment().unix()
          const res = await dispatch(getOrders({
            store: filterStore, order_status,
            startDate: moment(startDate).startOf("day").format("x"),
            endDate: moment(endDate).endOf("day").format("x"),
            currentPage,
            search,
            version: hash,
            type, error_order: true
          }))

        });
      })
    }
  }

  const capitalizeAndColorBeforeColon = (note) => {
    const lines = note.split('\n');
    const totalLines = lines.length;
    const linesToShow = 3;

    const displayLines = totalLines > linesToShow
      ? ['...'].concat(lines.slice(totalLines - linesToShow))
      : lines;

    return displayLines.map((line, index) => {
      const [beforeColon, afterColon] = line.split(':', 2);
      const capitalizedBeforeColon = beforeColon.trim().charAt(0).toUpperCase() + beforeColon.trim().slice(1);
      return (
        <div key={index} style={{ marginBottom: index < displayLines.length - 1 ? '4px' : '0' }}>
          <span style={{ 
            color: '#d32f2f', 
            fontWeight: 600,
            fontSize: '11px'
          }}>{capitalizedBeforeColon}</span>
          <span style={{ color: '#666', marginLeft: '3px' }}>: {afterColon ? afterColon.trim() : ""}</span>
        </div>
      );
    });
  };
  function getFirstWords(text) {
    if (text && text.length > 35) {
      return text.substring(0, 35) + "...";
    } else {
      return text || "";
    }
  }
  const handleDeleteNote = async (index) => {
    const updatedNotes = itemEditor.note.split("\n").filter((_, i) => i !== index);
    const res = await dispatch(editOrder({ user, field: "note", string: updatedNotes.join("\n"), id: itemEditor.id }))
    if (res.payload.status == 0) {
      // await dispatch(
      //   getOrders({
      //     store: filterStore, order_status,
      //     startDate: moment(startDate).startOf("day").format("x"),
      //     endDate: moment(endDate).endOf("day").format("x"), currentPage, search, type
      //   })
      // );
      bcrypt.genSalt(10, (err, salt) => {
        bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
          const time = moment().unix()
          const res = await dispatch(getOrders({
            store: filterStore, order_status,
            startDate: moment(startDate).startOf("day").format("x"),
            endDate: moment(endDate).endOf("day").format("x"),
            currentPage,
            search,
            version: hash,
            type, error_order: true
          }))

        });
      })
    }
    setOpen2(false)
  };
  useEffect(() => {
    bcrypt.genSalt(10, (err, salt) => {
      bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
        const time = moment().unix()
        const res = await dispatch(getOrders({
          store: filterStore, order_status,
          startDate: moment(startDate).startOf("day").format("x"),
          endDate: moment(endDate).endOf("day").format("x"),
          currentPage,
          search,
          version: hash,
          type, error_order: true
        }))

      });
    })
  }, [startDate, endDate, currentPage]);

  const orderStatusAccent = (status) => {
    switch (status) {
      case "error":
      case "cancelled":
        return "#dc2626";
      case "refund":
        return "#ea580c";
      case "delivered":
        return "#16a34a";
      case "case_item":
      case "case_des":
      case "fraudulent":
      case "case_other":
      case "undelivered":
        return "#0d9488";
      default:
        return "#94a3b8";
    }
  };

  const orderStatusTintBg = (status) => {
    switch (status) {
      case "error":
      case "cancelled":
        return "#fef2f2";
      case "refund":
        return "#fff7ed";
      case "delivered":
        return "#f0fdf4";
      case "case_item":
      case "case_des":
      case "fraudulent":
      case "case_other":
      case "undelivered":
        return "#ecfeff";
      default:
        return "#ffffff";
    }
  };

  const orderStatusTintBorder = (status) => {
    switch (status) {
      case "error":
      case "cancelled":
        return "#fecaca";
      case "refund":
        return "#fed7aa";
      case "delivered":
        return "#bbf7d0";
      case "case_item":
      case "case_des":
      case "fraudulent":
      case "case_other":
      case "undelivered":
        return "#a5f3fc";
      default:
        return "#e2e8f0";
    }
  };



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ paddingTop: '24px', paddingBottom: '24px' }}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <div style={{ paddingTop: '24px' }}>
                <HTMLDataTable
                  table={{
                    columns: [
                      { Header: "Date", accessor: "date", align: "left" },
                      { Header: "Order Id", accessor: "order_id", align: "left" },
                      { Header: "Shield", accessor: "shield", align: "left" },
                      { Header: "Price", accessor: "price", align: "center" },
                      { Header: "Tracking", accessor: "tracking", align: "center" },
                      { Header: "Input Web", accessor: "import", align: "center" },
                      { Header: "Customer", accessor: "customer", align: "left" },
                      { Header: "Message to Customer", accessor: "is_message_to_customer", align: "left" },
                      { Header: "Fulfil", accessor: "fulfil", align: "left" },
                      {
                        Header: (
                          <div style={{ textAlign: "center", lineHeight: 1.25 }}>
                            <div>Call to customer</div>
                          </div>
                        ),
                        accessor: "nhung_check",
                        align: "center",
                      },
                      { Header: "Order Status", accessor: "error_order", align: "left" },
                      { Header: "Note", accessor: "note", align: "left" },
                    ],
                    rows: data.data && data.data.length > 0 ? [...data.data.filter(item => item.price && item.error_order == "error").map((items, index) => ({
                      order_status: items.error_order,
                      id: items.order_id,
                      cancel: items.tracking,
                      itemEditor: itemEditor.order_id,
                      date: <>
                        {items.price || search ? <span className={items?.price > 0 ? "tc-text" : "tc-muted"}>{moment(items.date).format("HH:mm DD/MM")}</span> : ""}
                      </>,
                      order_id: <>
                        {items.price || search ? (
                          <div className="tc-stack">
                            <p className={items.price ? "tc-text" : "tc-muted"}>{items.order_id}</p>
                            <div className="tc-row">
                              {items?.store_name == "Sesverin" || items?.store_name == "Navlak" || items?.store_name == "Ladyjacket" || items?.store_name == "Atorcus" || items?.store_name == "Prashirt" || items?.store_name == "Thalath" ?
                                <img src="https://egead.nyc3.digitaloceanspaces.com/1728270648803h7puf0.jpg" alt="" style={{ height: 16, borderRadius: 3 }} />
                                : null}
                              <p className="tc-muted">{items.store_name}</p>
                              <button type="button" className="tc-icon-btn" onClick={() => handleShowInformation(items)} title="Order info"><InfoOutlinedIcon /></button>
                            </div>
                          </div>
                        ) : ""}
                      </>,
                      shield: (
                        <div>
                          {items.price ? (<div style={{ display: "flex", flexDirection: "row" }}><img src={items.shield.includes("PayPal:") ? "https://egead.nyc3.digitaloceanspaces.com/pp.png" : items.shield.includes("Stripe:") ? "https://egead.nyc3.digitaloceanspaces.com/stripe.png" : items.shield.includes("AirWallex:") ? "https://egead.nyc3.digitaloceanspaces.com/1732162753304ylmhtm.jpg" : "https://egead.nyc3.digitaloceanspaces.com/card.png"} style={{ width: 20, marginRight: 5 }}></img>{items.shield.replace("PayPal:", "").replace("Stripe:", "").replace("Stripe", "").replace("AirWallex:", "")}</div>
                          ) : null}
                        </div>
                      ),
                      price: items.price ? (
                        <div className="tc-row">
                          <span className="tc-label">Price</span>
                          <span className="tc-money tc-money--ok">${items.price}</span>
                        </div>
                      ) : null,
                      tracking: (
                        <TrackingCell
                          tracking={items.tracking}
                          deli={items.deli}
                          isDeli={items.is_deli}
                          status={items.status}
                          cong={items.cong}
                          emptyTrack="Click to add"
                          onTrackClick={
                            items.tracking && items.tracking !== "cancel" && items.tracking !== "refund"
                              ? () => handleCopyClick(items.tracking)
                              : undefined
                          }
                        />
                      ),
                      import: (
                        <> {items.price ?
                          <FormControlLabel
                            control={<Checkbox checked={items?.mai}
                              icon={
                                <span
                                  style={{
                                    borderRadius: '50%',
                                    width: 20,
                                    height: 20,
                                    borderColor: 'black',
                                    borderWidth: 1,
                                    borderStyle: 'solid',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                />
                              }
                              checkedIcon={
                                <span
                                  style={{
                                    borderRadius: '50%',
                                    width: 20,
                                    height: 20,
                                    backgroundColor: '#1976d2',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <CheckIcon style={{ color: 'white', fontSize: 16 }} />
                                </span>
                              }
                              onClick={() => permission.includes("mai") ? changeCheckBox(items, items?.mai, "mai", items.id) : null} />}
                          /> : null
                        }</>
                      ),
                      customer: <div style={{ display: "flex", flexDirection: "column" }}>
                        <span className="caption-text" style={{ fontSize: "0.75rem", fontWeight: "bold", color: items?.price > 0 ? "black" : "#344767" }}>{items.shipping_method}</span>
                        <div
                          style={{
                            display: "inline-flex",
                            maxWidth: "220px",
                            alignItems: "center",
                            gap: 4,
                            color: items?.price > 0 ? "black" : "#344767",
                            fontSize: "0.75rem",
                            fontWeight: items?.price > 0 ? 500 : 400,
                            lineHeight: 1.35,
                          }}
                        >
                          <span
                            className="caption-text"
                            title={items.email ? "Copy email" : undefined}
                            onClick={() => handleCopyEmail(items.email)}
                            style={{
                              cursor: items.email ? "pointer" : "default",
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                              color: "inherit",
                              fontWeight: "inherit",
                            }}
                          >
                            {items.email || (canEditCustomerEmail ? "Add customer email" : "")}
                          </span>
                          {canEditCustomerEmail ? (
                            <button
                              type="button"
                              aria-label={`Edit customer email for order ${items.order_id}`}
                              title="Edit customer email"
                              onClick={() => handleOpenEmailEditor(items)}
                              style={{
                                display: "inline-flex",
                                padding: 0,
                                border: 0,
                                background: "transparent",
                                color: "inherit",
                                cursor: "pointer",
                                flexShrink: 0,
                              }}
                            >
                              <EditOutlinedIcon sx={{ fontSize: 14 }} />
                            </button>
                          ) : null}
                        </div>
                      </div >,
                      fulfil: (
                        <>
                          {items?.fulfil ? (
                            <span style={{
                              display: 'inline-block',
                              padding: '3px 10px',
                              fontSize: '0.75rem',
                              fontWeight: 600,
                              color: '#fff',
                              backgroundColor: '#1976d2',
                              borderRadius: '10px'
                            }}>
                              {items?.fulfil.toUpperCase().includes("MX") ? "Merchfox" : items?.fulfil.toUpperCase().includes("MO") ? "Mango" : items?.fulfil.toUpperCase().includes("BF") ? "Beeful" : items?.fulfil.toUpperCase().includes("PY") ? "Printway" : items?.fulfil.toUpperCase().includes("PTY") ? "Printify" : items?.fulfil.toUpperCase().includes("A2K") ? "A2K" : items?.fulfil.toUpperCase().includes("BG") ? "BugerPrint" : items.fulfil}
                            </span>
                          ) : null}
                        </>
                      ),
                      is_message_to_customer: (
                        <>
                          {items.price ?
                            <FormControlLabel
                              control={<Checkbox checked={items?.is_message_customer}
                                icon={
                                  <span
                                    style={{
                                      borderRadius: '50%',
                                      width: 20,
                                      height: 20,
                                      borderColor: 'black',
                                      borderWidth: 1,
                                      borderStyle: 'solid',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  />
                                }
                                checkedIcon={
                                  <span
                                    style={{
                                      borderRadius: '50%',
                                      width: 20,
                                      height: 20,
                                      backgroundColor: '#1976d2',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <CheckIcon style={{ color: 'white', fontSize: 16 }} />
                                  </span>
                                }
                                onClick={() => permission.includes("is_message_customer") ? changeCheckBox(items, items?.is_message_customer, "is_message_customer", items.id) : null} />}
                            /> : null
                          }
                        </>
                      ),
                      nhung_check: items.price && items.call ?
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 5, maxWidth: "148px" }}>
                          <FormControlLabel
                            sx={{ margin: 0 }}
                            control={<Checkbox checked={items?.nhung}
                              icon={
                                <span
                                  style={{
                                    width: 20,
                                    height: 20,
                                    borderWidth: 1,
                                    borderColor: 'black',
                                    borderStyle: 'solid',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                />
                              }
                              checkedIcon={
                                <span
                                  style={{
                                    borderRadius: '50%',
                                    width: 20,
                                    height: 20,
                                    backgroundColor: '#1976d2',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <CheckIcon style={{ color: 'white', fontSize: 16 }} />
                                </span>
                              }
                              onClick={() => permission.includes("nhung") ? changeCheckBox(items, items?.nhung, "nhung", items.id) : null} />}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 5,
                              padding: "4px 7px",
                              borderRadius: 6,
                              width: "100%",
                              boxSizing: "border-box",
                              background: "#fffbeb",
                              border: "1px solid rgba(251, 191, 36, 0.35)",
                            }}
                          >
                            <PhoneInTalkOutlined style={{ fontSize: 14, color: "#ca8a04", flexShrink: 0 }} />
                            <span
                              style={{
                                fontSize: "10px",
                                fontWeight: 600,
                                color: "#713f12",
                                lineHeight: 1.25,
                              }}
                            >
                              Cần gọi Confirm Order
                            </span>
                          </div>
                        </div> : null
                      ,
                      error_order: (() => {
                        const statusVal = items.error_order || "none";
                        return (
                        <FormControl
                          fullWidth
                          size="small"
                          sx={{ minWidth: 156, maxWidth: 198 }}
                        >
                          <Select
                            id={`delivery-status-${items.order_id}-${index}`}
                            value={statusVal}
                            onChange={(e) => handleChangeDeli(e, items)}
                            displayEmpty
                            inputProps={{ "aria-label": "Order status" }}
                            renderValue={(value) => {
                              const option = deliStatus.find((o) => o.value === value) || deliStatus[0];
                              return (
                                <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                  <span
                                    style={{
                                      width: 8,
                                      height: 8,
                                      borderRadius: "50%",
                                      backgroundColor: orderStatusAccent(value),
                                      flexShrink: 0,
                                      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.06)",
                                    }}
                                  />
                                  <span style={{ fontSize: "0.8125rem", fontWeight: 500, color: "#334155", lineHeight: 1.2 }}>
                                    {option.name}
                                  </span>
                                </span>
                              );
                            }}
                            sx={{
                              height: 36,
                              borderRadius: "8px",
                              bgcolor: orderStatusTintBg(statusVal),
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: orderStatusTintBorder(statusVal),
                              },
                              "&:hover": {
                                bgcolor: orderStatusTintBg(statusVal),
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor:
                                  statusVal === "none" ? "#cbd5e1" : orderStatusTintBorder(statusVal),
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor:
                                  statusVal === "none" ? "#64748b" : orderStatusAccent(statusVal),
                                borderWidth: 1,
                              },
                              "& .MuiSelect-select": {
                                py: 0.85,
                                px: 1.25,
                                display: "flex",
                                alignItems: "center",
                              },
                              "& .MuiSelect-icon": {
                                color: "#64748b",
                              },
                            }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  borderRadius: "8px",
                                  mt: 0.5,
                                  boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.07), 0 2px 4px -2px rgb(0 0 0 / 0.07)",
                                  border: "1px solid #e2e8f0",
                                  maxHeight: 320,
                                },
                              },
                              anchorOrigin: { vertical: "bottom", horizontal: "left" },
                              transformOrigin: { vertical: "top", horizontal: "left" },
                            }}
                          >
                            {deliStatus.map((option) => (
                              <MenuItem
                                key={option.value}
                                value={option.value}
                                sx={{
                                  fontSize: "0.8125rem",
                                  fontWeight: 500,
                                  py: 1,
                                  px: 1.5,
                                  gap: 1.25,
                                  color: "#334155",
                                  display: "flex",
                                  alignItems: "center",
                                  "&:hover": { bgcolor: "#f8fafc" },
                                  "&.Mui-selected": {
                                    bgcolor: "#f1f5f9",
                                    "&:hover": { bgcolor: "#e2e8f0" },
                                  },
                                }}
                              >
                                <span
                                  style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                    backgroundColor: orderStatusAccent(option.value),
                                    flexShrink: 0,
                                    boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.06)",
                                  }}
                                />
                                {option.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        );
                      })(),

                      note: (
                        <NoteCell
                          customerNote={items.price ? items.customer_note : ""}
                          note={items.note}
                          canEdit={permission.includes("note")}
                          onAdd={() => handleAddNote(items)}
                        />
                      ),

                    })
                    )] : []
                  }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: '5px' }}>
                  <MDPageBar
                    totalPage={data.totalPage}
                    currentPage={currentPage}
                    onChange={handleChangePage}
                  />
                </div>
              </div>
            </Card>
          </Grid>
        </Grid>
      </div>
      <NoteDialog open2={open2} handleDeleteNote={handleDeleteNote} handleClose2={handleClose2} note2={note} note={itemEditor.note} user={user.replace("@gmail.com", "")} setNote={setNote} handleChangeNote={handleChangeNote} />
      <Dialog open={openEmail} onClose={() => setOpenEmail(false)} fullWidth maxWidth="xs">
        <DialogTitle>Edit Customer Email</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            type="email"
            label="Customer email"
            value={customerEmail}
            onChange={(event) => setCustomerEmail(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                handleSaveCustomerEmail();
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEmail(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSaveCustomerEmail}>Update Email</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={open4} onClose={handleClose4}>
        <DialogTitle>Information</DialogTitle>
        <DialogContent>
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <GreenSection>
              <CaptionText>Order ID: <InfoText>{itemEditor.order_id}</InfoText></CaptionText>
              <CaptionText>Store: <InfoText>{itemEditor.store_name}</InfoText></CaptionText>
              <CaptionText>Payment Method: <div style={{ display: "flex", flexDirection: "row", marginLeft: 5 }}><img src={itemEditor.shield ? itemEditor.shield.includes("PayPal:") ? "https://egead.nyc3.digitaloceanspaces.com/pp.png" : itemEditor.shield.includes("Stripe:") ? "https://egead.nyc3.digitaloceanspaces.com/stripe.png" : "https://egead.nyc3.digitaloceanspaces.com/card.png" : "https://egead.nyc3.digitaloceanspaces.com/card.png"} style={{ height: 20, marginRight: 5 }}></img>{itemEditor.shield ? itemEditor.shield.replace("PayPal:", "").replace("Stripe:", "").replace("Stripe", "") : itemEditor.shield}</div></CaptionText>
            </GreenSection>
            <hr style={{ marginTop: 10, marginBottom: 10 }} />
            {data.data ? data.data.filter(item => item.order_id === itemEditor.order_id && item.store_name === itemEditor.store_name).map((items, index) => (
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", position: "relative" }} key={index} >
                <BlueSection >
                  <img src={items.images} style={{ width: "60px", objectFit: "contain", marginRight: "10px" }}></img>
                  <div>
                    <CaptionText>
                      <a href={items.link} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 5, marginRight: "5px", fontWeight: '400' }}>{items.items_name}</a>
                    </CaptionText>
                    <CaptionText>
                      <NormalText>{sizeHasHtml(items.size) ? <SizeHtml value={items.size} /> : (items.size ? items.size.replace("Type: ", "").replace("Fabric Brand: ", "").replace("Style: ", "").replace("Size: ", "").replace("Product Sides Options: ", "") : "")} - <RedText>{items.color}</RedText></NormalText>
                    </CaptionText>
                  </div>
                </BlueSection>
                <span style={{ position: "absolute", top: -7, right: -9, background: "white", borderRadius: "100%", width: "25px", height: "25px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <strong style={{ color: "black" }}>{items.quantity}</strong>
                </span>
              </div>
            )) : null}
            <hr style={{ marginTop: 10, marginBottom: 10 }} />
            <DarkSection>
              <CaptionText2>
                Ship to: <NormalText><HighlightedText>{itemEditor.customer_name}</HighlightedText> - {itemEditor?.address ? `${itemEditor?.address[0]} ${itemEditor?.address[1]}, ${itemEditor?.address[2]}, ${itemEditor?.address[3]} ${itemEditor?.address[4]}, United States` : null}</NormalText>
              </CaptionText2>
              <CaptionText2>
                Email: <NormalText>{itemEditor.email}</NormalText>
              </CaptionText2>
              <CaptionText2>
                Customer Phone: <NormalText>{itemEditor.phone ? itemEditor.phone.includes("+1") ? itemEditor.phone : `+1 ${itemEditor.phone}` : ""}</NormalText>
              </CaptionText2>
            </DarkSection>
          </div>
        </DialogContent>
      </Dialog>
      <Footer />
    </DashboardLayout >
  );
}

export default ErrorOrder;
